import { api } from '../lib/api'
import { useApi } from '../lib/useApi'

export function ServerStatus() {
  const { data, loading, error } = useApi('server-status', api.serverStatus)
  const status = data?.data.status
  const label = loading
    ? 'Verifica server'
    : error
      ? 'Stato non disponibile'
      : status === 'online'
        ? 'TNTWars online'
        : 'TNTWars offline'

  return (
    <div className={`server-status server-status--${status ?? 'unknown'}`}>
      <span className="server-status__dot" aria-hidden="true" />
      <span>{label}</span>
      {data?.data.backends.activeMatches ? (
        <span className="server-status__meta">
          {data.data.backends.activeMatches} match attivi
        </span>
      ) : null}
    </div>
  )
}
